import { Box } from "@material-ui/core";
import style from "./informations.module.scss";
import ShimmerBox from "components/shared/shimmer-box";

const InformationsShimmer = () => {
  return (
    <>
      <Box
        sx={{
          gridGap: 10,
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <ShimmerBox classes={style.chip} height="0px" width="80px" />
        <ShimmerBox classes={style.chip} height="0px" width="80px" />
        <ShimmerBox classes={style.chip} height="0px" width="80px" />
        <ShimmerBox classes={style.chip} height="0px" width="80px" />
        <ShimmerBox classes={style.chip} height="0px" width="80px" />
        <ShimmerBox classes={style.chip} height="0px" width="80px" />
        <ShimmerBox classes={style.chip} height="0px" width="80px" />
        <ShimmerBox classes={style.chip} height="0px" width="80px" />
      </Box>
    </>
  );
};

export default InformationsShimmer;
